var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1255 15.542L9.10448 10.521C8.68781 10.8123 8.19814 11.0413 7.63548 11.208C7.07348 11.3747 6.50781 11.458 5.93848 11.458C4.41048 11.458 3.11181 10.9233 2.04248 9.85401C0.973143 8.78467 0.438477 7.48601 0.438477 5.95801C0.438477 4.43067 0.973143 3.13234 2.04248 2.06301C3.11181 0.993008 4.41048 0.458008 5.93848 0.458008C7.46581 0.458008 8.76414 0.993008 9.83348 2.06301C10.9035 3.13234 11.4385 4.43067 11.4385 5.95801C11.4385 6.52734 11.3618 7.07601 11.2085 7.60401C11.0558 8.13201 10.8268 8.61801 10.5215 9.06201L15.5625 14.104L14.1255 15.542ZM5.93848 9.41701C6.91048 9.41701 7.72981 9.08367 8.39648 8.41701C9.06314 7.75034 9.39648 6.93067 9.39648 5.95801C9.39648 4.98601 9.06314 4.16667 8.39648 3.50001C7.72981 2.83334 6.91048 2.50001 5.93848 2.50001C4.96581 2.50001 4.14614 2.83334 3.47948 3.50001C2.81281 4.16667 2.47948 4.98601 2.47948 5.95801C2.47948 6.93067 2.81281 7.75034 3.47948 8.41701C4.14614 9.08367 4.96581 9.41701 5.93848 9.41701Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.f79d59589a1cbb555387ea36cadd2507.svg";